<template>
  <div>
    <router-view />
    <section class="section mt-10" v-if="user">
      <div class="d-flex justify-content-between align-items-center my-20">
        <h1 class="section__header">Make a Booking</h1>
      </div>
      <div class="row mt-10">
        <div class="col-12 col-md-6">
          <input-main
            class="block rounded-10 overflow-h"
            @response="onOpenModal"
          ></input-main>
        </div>
        <div class="col-12 col-md-6">
          <div class="section__block block rounded-10 p-20">
            <div class="block-content p-0">
              <Schedules @onEdit="handleOnEdit" :user="user" :orders="orders" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <ModalBooking
      v-if="isModalOpen"
      @close="onCloseModal"
      @submit="onSubmitModal"
      :data="modalData"
      :orderIndex="orderIndex"
      :order="orderData"
    ></ModalBooking>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalBooking from "@/components/booking/ModalBooking";
import Schedules from "@/components/booking/Schedules";
import InputMain from "./service/InputMain";

export default {
  components: {
    ModalBooking,
    Schedules,
    InputMain
  },
  props: {
    user: {
      type: [Object],
      default: null
    }
  },
  data() {
    return {
      isModalOpen: false,
      locationId: null,
      categoryId: null,
      orderData: null,
      orderIndex: null
    };
  },
  computed: {
    modalData() {
      return {
        locationId: this.locationId,
        categoryId: this.categoryId
      };
    },
    orders() {
      return this.getOrders();
    }
  },
  methods: {
    ...mapActions({
      ORDER_ADD_SCHEDULE: "ORDER_ADD_SCHEDULE",
      ORDER_SET_BY_INDEX: "ORDER_SET_BY_INDEX"
    }),
    ...mapGetters({
      getOrders: "getOrders"
    }),
    handleOnEdit(content) {
      this.orderIndex = content.index;
      this.orderData = content.data;
      this.onOpenModal({
        location: this.locationId,
        category: this.categoryId
      });
    },
    onOpenModal({ location, category }) {
      this.categoryId = category;
      this.locationId = location;
      this.isModalOpen = true;
    },
    onSubmitModal(schedule) {
      if (this.orderIndex !== null) {
        this.ORDER_SET_BY_INDEX({ index: this.orderIndex, order: schedule });
      } else {
        this.ORDER_ADD_SCHEDULE(schedule);
      }
      this.onCloseModal();
    },
    onCloseModal() {
      this.orderData = null;
      this.orderIndex = null;
      this.isModalOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  .block {
    min-height: 500px;
  }
  &__header {
    color: $gray-900;
    margin-bottom: 0;
    font-size: $font-size-lg;
  }
  &__block {
    padding: 30px;
  }
  &__content {
    width: 100%;
  }
  .overflow-h {
    overflow: hidden;
  }
}
</style>
